import request from '@dashboard/services/request';

const { REACT_APP_API_URL: apiUrl } = process.env;

export const resetPassword = (data, resetPasswordToken) =>
  request(`${apiUrl}/user/reset-password/${resetPasswordToken}`, null, {
    body: JSON.stringify(data),
    method: 'POST',
  });
